module.exports = __webpack_public_path__ + "static/media/ph-e.c04ed583.JPG";